import "../App.css";
import { React, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import PaidIcon from "@mui/icons-material/Paid";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import GroupsIcon from "@mui/icons-material/Groups";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ApartmentIcon from "@mui/icons-material/Apartment";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpIcon from "@mui/icons-material/Help";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import Groups3Icon from "@mui/icons-material/Groups3";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SmsIcon from "@mui/icons-material/Sms";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Badge from "@mui/material/Badge";

import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import HomeIcon from "@mui/icons-material/Home";
import { experimentalStyled as styled, useTheme } from "@mui/material/styles";
import Home from "./Home";
import Tenants from "../pages/Tenants";
import Profile from "../pages/Profile";
import FAQs from "../pages/Faqs";

import {
  Routes,
  useLocation,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import Notification from "../popup/Notification";
import ConfirmDialog from "../dialog/ConfirmDialog";
import AddPopup from "../popup/AddPopup";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Admins from "../pages/Admins";
import TenantWorkers from "../pages/TenantWorkers";
import Jobs from "../pages/Jobs";
import Speciality from "../pages/Speciality";
import Roles from "../pages/Roles";
import Status from "../pages/Status";
import Locations from "../pages/Locations";
import PaymentModes from "../pages/PaymentModes";
import TenantAdmins from "../pages/TenantsAdmins";
import { useMediaQuery } from "react-responsive";
import ChangePassword from "../forms/ChangePassword";

// ********************************************** Permanent drawer START *******************************************
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader1 = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar1 = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer1 = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const moreItems = ["Profile", "Change Password", "Logout"];
// ********************************************** Permanent drawer END *******************************************

function Sidenav(props) {
  const theme = useTheme();
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 });
  const isBigScreen = useMediaQuery({ minWidth: 1824 });
  const showPermanentDrawer = isDesktopOrLaptop || isBigScreen;

  const [anchorEl, setAnchorEl] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);

  // Users
  const [openUsers, setOpenUsers] = useState(false);
  const handleUsersClick = () => {
    setOpenUsers(!openUsers);
  };

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const contentStyle = {
    flexGrow: 1,
    padding: 24,
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const { setAuth } = useAuth();
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const LOGOUT = "/api/v1/users/logout/";

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  // ********************************************** Permanent drawer START AGAIN *********************************
  const [open, setOpen] = useState(true);

  const handleDrawerOpenPermanent = () => {
    setOpen(true);
  };

  const handleDrawerClosePermanent = () => {
    setOpen(false);
  };
  // ********************************************** Permanent drawer END AGAIN *********************************

  // ********************************************** Responsive drawer START *******************************************

  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    //if (!isClosing) {
    //setMobileOpen(!mobileOpen);
    //}
  };

  const closeMobileDrawer = (shouldClose) => () => {
    if (!showPermanentDrawer) {
      setMobileOpen(shouldClose);
    }
  };

  const drawer = (
    <div>
      {/* Drawer header on mobile devices screens */}
      {!showPermanentDrawer && (
        <DrawerHeader1>
          <IconButton
            onClick={handleDrawerClose}
            sx={{
              color: "white",
            }}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader1>
      )}

      {/* Drawer header on large screens e.g., laptop, PC, etc */}
      {showPermanentDrawer && (
        <DrawerHeader1>
          <IconButton
            onClick={handleDrawerClosePermanent}
            sx={{
              color: "white",
            }}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader1>
      )}
      <Divider />
      <List
        sx={{
          // selected and (selected + hover) states
          "&& .Mui-selected, && .Mui-selected:hover": {
            bgcolor: "rgba(67, 176, 42, .9)",
            "&, & .MuiListItemIcon-root": {
              color: "white",
            },
          },
          // hover states
          "& .MuiListItemButton-root:hover": {
            bgcolor: "rgba(67, 176, 42, .5)",
            "&, & .MuiListItemIcon-root": {
              color: "rgba(67, 176, 42)",
            },
            cursor: "pointer",
          },
          color: "white",
        }}
      >
        <ListItemButton
          selected={pathname === "/"}
          to={"/"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        <ListItemButton
          selected={pathname === "/roles"}
          to={"/roles"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <AdminPanelSettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Roles" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        <ListItemButton
          selected={pathname === "/status"}
          to={"/status"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <CenterFocusStrongIcon />
          </ListItemIcon>
          <ListItemText primary="Status" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        <ListItemButton
          selected={pathname === "/locations"}
          to={"/locations"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <GpsFixedIcon />
          </ListItemIcon>
          <ListItemText primary="Locations" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        <ListItemButton
          selected={pathname === "/payment-modes"}
          to={"/payment-modes"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <PaidIcon />
          </ListItemIcon>
          <ListItemText
            primary="Payment Modes"
            sx={{ opacity: open ? 1 : 0 }}
          />
        </ListItemButton>

        <ListItemButton
          selected={pathname === "/specialities"}
          to={"/specialities"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Specialities" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        <ListItemButton
          selected={pathname === "/tenants"}
          to={"/tenants"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <ApartmentIcon />
          </ListItemIcon>
          <ListItemText primary="Tenants" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>

        <ListItemButton
          sx={{
            pl: 4,
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
          onClick={handleUsersClick}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <GroupsIcon />
          </ListItemIcon>
          <ListItemText primary="Users" sx={{ opacity: open ? 1 : 0 }} />
          {openUsers ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openUsers} timeout="auto" unmountOnExit>
          <Divider color="white" />
          <List component="div" disablePadding>
            <ListItemButton
              selected={pathname === "/admins"}
              to={"/admins"}
              component={Link}
              sx={{
                pl: 4,
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
              onClick={closeMobileDrawer(false)}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                <PeopleAltIcon />
              </ListItemIcon>
              <ListItemText
                primary="Business Admins"
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>

            <ListItemButton
              selected={pathname === "/tenant-admins"}
              to={"/tenant-admins"}
              component={Link}
              sx={{
                pl: 4,
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
              onClick={closeMobileDrawer(false)}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                <Groups3Icon />
              </ListItemIcon>
              <ListItemText
                primary="Tenant Admins"
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>

            <ListItemButton
              selected={pathname === "/workers"}
              to={"/workers"}
              component={Link}
              sx={{
                pl: 4,
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
              onClick={closeMobileDrawer(false)}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                <Diversity3Icon />
              </ListItemIcon>
              <ListItemText
                primary="Tenant Workers"
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton
          selected={pathname === "/jobs"}
          to={"/jobs"}
          component={Link}
          onClick={closeMobileDrawer(false)}
          sx={{
            pl: 4,
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color: "white",
            }}
          >
            <WorkspacesIcon />
          </ListItemIcon>
          <ListItemText primary="Jobs" sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>
      </List>
      <Divider color="white" />
      <List
        sx={{
          // selected and (selected + hover) states
          "&& .Mui-selected, && .Mui-selected:hover": {
            bgcolor: "rgba(67, 176, 42, .9)",
            "&, & .MuiListItemIcon-root": {
              color: "white",
            },
          },
          // hover states
          "& .MuiListItemButton-root:hover": {
            bgcolor: "rgba(67, 176, 42, .5)",
            "&, & .MuiListItemIcon-root": {
              color: "rgba(67, 176, 42)",
            },
            cursor: "pointer",
          },
          color: "white",
        }}
      >
        {[
          {
            text: "Profile",
            to: "/profile",
            icon: <AccountCircle />,
          },
          {
            text: "FAQs",
            to: "/faqs",
            icon: <QuestionAnswerIcon />,
          },
        ].map((item, index) => (
          <ListItem
            key={index}
            disablePadding
            to={item.to}
            component={Link}
            sx={{
              display: "block",
              color: "white",
            }}
          >
            <ListItemButton
              selected={pathname === item.to}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
              onClick={closeMobileDrawer(false)}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );
  // ********************************************** Responsive drawer End *******************************************

  const handleNotificationsClicked = () => {
    //alert("Coming soon");
  };
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItemClicked = (event, value) => {
    handleProfileMenuClose();
    //console.log("Clicked", value);
    //alert(`${value} coming soon`);
    if (`${value}` === `Logout`) {
      //signOut();
      setConfirmDialog({
        isOpen: true,
        title: "Are you sure you want to Logout?",
        subTitle: "Your current session will be terminated",
        action: "Continue",
        onConfirm: () => {
          logoutRequest();
        },
      });
    }

    if (`${value}` === `Profile`) {
      //setMenudata("Profile");
      //console.log("profile");
      navigate("/profile", {
        replace: true,
      });
    }

    if (`${value}` === `Change Password`) {
      setOpenPopup(true);
    }
  };
  const menuId = "primary-search-account-menu";

  const appBar = (
    <div>
      <Toolbar>
        {/* App Bar Menu Icon on mobile screens */}
        {!showPermanentDrawer && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* App Bar Menu Icon on large screens e.g., laptop, PC, etc */}
        {showPermanentDrawer && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => {
              setOpen(!open);
            }}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* Toolbar App Logo */}
        <Box ml={1} mt={1} mr={2}>
          {" "}
          <img src="./logo512.png" height={30} alt="App Icon" />
        </Box>
        {/* Toolbar App Title */}
        <Typography variant="h6" noWrap component="div">
          BUUKIPA Business
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        {/* Toolbar Menu */}
        <Box sx={{ display: { xs: "none", md: "flex" } }}>
          <Tooltip title="Notifications">
            <IconButton
              size="large"
              aria-label="show new notifications"
              color="inherit"
              onClick={handleNotificationsClicked}
            >
              <Badge badgeContent={1} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          <Tooltip title="More">
            {/* <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton> */}
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleProfileMenuClose}
          >
            {moreItems.map((setting) => (
              <MenuItem
                key={setting}
                onClick={(e) => menuItemClicked(e, setting)}
              >
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </div>
  );

  const logoutRequest = async () => {
    setBackdropOpen(true);
    try {
      const response = await axiosPrivate.put(`${LOGOUT}${auth.id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(response);
      setBackdropOpen(false);
      logOut();
    } catch (error) {
      var errorMessage = "";
      if (error.response) {
        // The client was given an error response (5xx, 4xx)
        const errorData = error.response.data;
        errorMessage = errorData.message;
      } else if (error.request) {
        // The client never received a response, and the request was never left
        errorMessage = "No server response";
      } else {
        // Anything else
        errorMessage = "Unexpected error occurred";
      }
      const errorTitle = "Failed To Logout";
      setConfirmDialog({
        isOpen: true,
        title: errorTitle,
        subTitle: errorMessage,
        action: "Retry",
        onConfirm: () => {
          logoutRequest();
        },
      });
      setBackdropOpen(false);
    }
  };

  // Close dialog upon successful profile update
  const closeDialog = (message) => {
    setOpenPopup(false);
    setNotify({
      isOpen: true,
      message: message,
      type: "success",
    });
    setTimeout(() => {
      logOut();
    }, 2000);
  };

  const logOut = () => {
    /* navigate("/login", {
      replace: true,
    }); */
    setAuth({});
    navigate("/login", {
      replace: true,
    });
  };

  // Remove this const when copying and pasting into your project.
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* App Bar on large screens e.g., laptop, PC, etc */}
      {showPermanentDrawer && (
        <AppBar1
          position="fixed"
          elevation={4}
          sx={{ backgroundColor: "#43B02A", color: "#ffffff" }}
        >
          {appBar}
        </AppBar1>
      )}

      {/* App Bar on mobile devices screens */}
      {!showPermanentDrawer && (
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          {appBar}
        </AppBar>
      )}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        {/* Drawer on mobile screens. Responsive. */}
        {!showPermanentDrawer && (
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                backgroundColor: "#36454F",
                width: drawerWidth,
              },
            }}
            slotProps={{
              root: {
                keepMounted: true, // Better open performance on mobile.
              },
            }}
          >
            {drawer}
          </Drawer>
        )}

        {/* Drawer on large screens e.g., laptop, PC, etc */}
        {showPermanentDrawer && (
          <Drawer1
            variant="permanent"
            open={open}
            PaperProps={{
              sx: {
                backgroundColor: "#36454F",
              },
            }}
          >
            {drawer}
          </Drawer1>
        )}
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 4,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Box height={40} />

        <main style={contentStyle}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admins" element={<Admins />} />
            <Route path="/tenant-admins" element={<TenantAdmins />} />
            <Route path="/workers" element={<TenantWorkers />} />
            <Route path="/specialities" element={<Speciality />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/status" element={<Status />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/payment-modes" element={<PaymentModes />} />
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/faqs" element={<FAQs />} />
          </Routes>
        </main>

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Notification notify={notify} setNotify={setNotify} />
        <AddPopup
          width="md"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          title="Change Password"
        >
          <ChangePassword closeDialog={closeDialog} />
        </AddPopup>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </Box>
  );
}

Sidenav.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default Sidenav;
